import { render, staticRenderFns } from "./BorrowerForm.vue?vue&type=template&id=06d21df0&"
import script from "./BorrowerForm.vue?vue&type=script&lang=js&"
export * from "./BorrowerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports